import React from 'react';

import { appMethod as app } from '@utils/app';
import './ScrollView.less';

/*
* 此组件的参数全部参考微信小程序srcoll-view组件，enable-back-to-top, enable-flex属性不支持。这里enable-flex等于是true，都是启用flexbox布局。
*
* 另外组件会接收className 和 style 属性
*
*/


export class ScrollView extends React.Component{
  
  constructor(props) {
    super(props);
    
    this.scrollDiv = React.createRef();

    this.scrollY = false;
    this.scrollX = false;
  }

  componentDidMount(){
    let data = this.props;
    let scrollDom =  this.scrollDiv.current;

    this.scrollY = data['scroll-y'] && data['scroll-y'] != 'false' ? true : false;
    this.scrollX = data['scroll-x'] && data['scroll-x'] != 'false' ? true : false;
    if(data['scroll-top']){
      this.setScrollTop(data['scroll-top']);
    }
    if(data['scroll-left']){
      this.setScrollLeft(data['scroll-left']);
    }
    if(data['scroll-into-view']){
      let intoDom = document.getElementById(data['scroll-into-view']);
      if(this.scrollX){
        this.setScrollLeft(intoDom.offsetLeft - scrollDom.offsetLeft);
      }
      if(this.scrollY){
        this.setScrollTop(intoDom.offsetTop - scrollDom.offsetTop);
      }
    }
  }

  componentDidUpdate(prevProps){
    let data = this.props;
    let scrollDom =  this.scrollDiv.current;
    if(data['scroll-top'] != prevProps['scroll-top']){
      this.setScrollTop(data['scroll-top']);
    }
    if(data['scroll-left'] != prevProps['scroll-left']){
      this.setScrollLeft(data['scroll-left']);
    }
    if(data['scroll-into-view'] != prevProps['scroll-into-view']){
      let intoDom = document.getElementById(data['scroll-into-view']);
      if(this.scrollX){
        this.setScrollLeft(intoDom.offsetLeft - scrollDom.offsetLeft);
      }
      if(this.scrollY){
        this.setScrollTop(intoDom.offsetTop - scrollDom.offsetTop);
      }
    }
  }

  // 设置滚动的高度
  topTimer = null;
  setScrollTop(top){
    let scrollDom =  this.scrollDiv.current;
    if(this.props['scroll-with-animation']){
      let oldTop = scrollDom.scrollTop;
      cancelAnimationFrame(this.topTimer);
      let variation = Math.abs(top - oldTop);
      let step = Math.ceil(variation / 10);
      let time = 0;
      let animateFn = () => {
        let newTop = oldTop < top ? this.easeInOut(time, oldTop, variation, step) : (oldTop - this.easeInOut(time, top, variation, step) + top);
        scrollDom.scrollTop = newTop;
        if(time < step){
          time++;
          this.topTimer = requestAnimationFrame(animateFn);
        }
      };
      this.topTimer = requestAnimationFrame(animateFn);
    }else{
      scrollDom.scrollTop = top;
    }
  }

  // 设置滚动的左侧位置
  leftTimer = null;
  setScrollLeft(left){
    let scrollDom =  this.scrollDiv.current;
    if(this.props['scroll-with-animation']){
      let oldLeft = scrollDom.scrollLeft;
      cancelAnimationFrame(this.leftTimer);
      let variation = Math.abs(left - oldLeft);
      let step = Math.ceil(variation / 10);
      let time = 0;
      let animateFn = () => {
        let newLeft = oldLeft < left ? this.easeInOut(time, oldLeft, variation, step) : (oldLeft - this.easeInOut(time, left, variation, step) + left);
        scrollDom.scrollLeft = newLeft;
        if(time < step){
          time++;
          this.leftTimer = requestAnimationFrame(animateFn);
        }
      };
      this.leftTimer = requestAnimationFrame(animateFn);
    }else{
      scrollDom.scrollLeft = left;
    }
  }

  easeInOut(t, b, c, d){
    if ((t/=d/2) < 1) return c/2*t*t*t + b;
    return c/2*((t-=2)*t*t + 2) + b;
  }

  oldScrollTop = 0;
  oldScrollLeft = 0;
  scrollAllowBottom = true;
  scrollAllowTop = true;
  scrollAllowLeft = true;
  scrollAllowRight = true;
  scrollEvent = (event) => {
    let scrollDom =  this.scrollDiv.current;
    this.props.bindscroll && this.props.bindscroll({
      ...event,
      detail: { 
        scrollLeft: scrollDom.scrollLeft,
        scrollTop: scrollDom.scrollTop,
        scrollHeight: scrollDom.scrollHeight,
        scrollWidth: scrollDom.scrollWidth,
        deltaX: this.oldScrollLeft - scrollDom.scrollLeft,
        deltaY: this.oldScrollTop - scrollDom.scrollTop
      }
    });

    let lowerThreshold = this.props['lower-threshold'] || 0;
    let upperThreshold = this.props['upper-threshold'] || 0;
    
    if((scrollDom.scrollTop + scrollDom.clientHeight >= scrollDom.scrollHeight - lowerThreshold) && this.oldScrollTop != scrollDom.scrollTop && this.scrollAllowBottom && this.scrollY){
      this.scrollAllowBottom = false;
      this.props.bindscrolltolower && this.props.bindscrolltolower({
        ...event,
        detail: {
          direction: 'bottom'
        }
      })
    }else if(scrollDom.scrollTop + scrollDom.clientHeight < scrollDom.scrollHeight - lowerThreshold){
      this.scrollAllowBottom = true;
    }
    if((scrollDom.scrollLeft + scrollDom.clientWidth >= scrollDom.scrollWidth - lowerThreshold) && this.oldScrollLeft != scrollDom.scrollLef && this.scrollAllowRight && this.scrollX){
      this.scrollAllowRight = false;
      this.props.bindscrolltolower && this.props.bindscrolltolower({
        ...event,
        detail: {
          direction: 'right'
        }
      })
    }else if(scrollDom.scrollLeft + scrollDom.clientWidth < scrollDom.scrollWidth - lowerThreshold){
      this.scrollAllowRight = true;
    }
    if(scrollDom.scrollTop <= 0 + upperThreshold && this.oldScrollTop != scrollDom.scrollTop && this.scrollAllowTop && this.scrollY){
      this.scrollAllowTop = false;
      this.props.bindscrolltoupper && this.props.bindscrolltoupper({
        ...event,
        detail: {
          direction: 'top'
        }
      })
    }else if(scrollDom.scrollTop > 0 + upperThreshold){
      this.scrollAllowTop = true;
    }
    if(scrollDom.scrollLeft <= 0 + upperThreshold && this.oldScrollLeft != scrollDom.scrollLeft && this.scrollAllowLeft && this.scrollX){
      this.scrollAllowLeft = false;
      this.props.bindscrolltoupper && this.props.bindscrolltoupper({
        ...event,
        detail: {
          direction: 'left'
        }
      })
    }else if(scrollDom.scrollLeft > 0 + upperThreshold){
      this.scrollAllowLeft = true;
    }

    this.oldScrollTop = scrollDom.scrollTop; //一定要放在最后面。
    this.oldScrollLeft = scrollDom.scrollLeft; //一定要放在最后面。
  }

  render(){
    const {
      id,
      className,
      style,
      hidden,
      children,
    } = this.props;
    // 传递参数中的data-参数
    let datasetObj = {};
    for (let key in this.props) {
      if (this.props.hasOwnProperty(key) && (key.indexOf('data-') === 0)) {
        datasetObj[key] = this.props[key];
      }
    }
    const styleObj = {...style};
    return (
      <div ref={this.scrollDiv} id={id} className={`jisu-component scroll-view scroll-view-wrapper ${className}`} style={{...style, overflowX: this.props['scroll-x'] ? 'auto' : 'hidden', overflowY: this.props['scroll-y'] ? 'auto' : 'hidden'}} {...datasetObj} hidden={hidden} onScroll={(event) => {this.scrollEvent(event)}}>{children}</div>
    );
  }
}


// WEBPACK FOOTER //
// ./src/jisu-component/scroll-view/ScrollView.jsx